import React from "react";
import { TextField } from "@mui/material";

const CustomTextField = ({
  type = "text",
  color,
  fontWeight,
  fontSize,
  error,
  helperText,
  borderColor,
  borderRadius ,
  placeholder,
  placeholderFontSize,
  placeholderColor,
   InputLabelProps,
   labelColor = "#572575",
   minWidth,
  ...props
}) => {
  return (
    <TextField
      variant="outlined"
      size="small"
      type={type}
      error={error}
      helperText={helperText}
      placeholder={placeholder}
    InputLabelProps={InputLabelProps} // ✅ forward slotProps to MUI
      sx={{
        minWidth,
        backgroundColor: "#FFFFFF !important",
        borderRadius: borderRadius?borderRadius  : "4px" ,
        "& .MuiOutlinedInput-root": {
          backgroundColor: "#FFFFFF",
          borderRadius: borderRadius?borderRadius  : "4px",
          borderColor: borderColor ? borderColor : "#E0E0E0",
          height: 36, // ⬅️ decrease overall field height
          minHeight: 36,
          "& fieldset": {
            borderColor: borderColor ? borderColor : "#E0E0E0",
            transition: "border-color 0.3s ease",
          },
          "&:hover fieldset": {
            borderColor: borderColor ? borderColor : "#E0E0E0",
          },
          "&.Mui-focused fieldset": {
            borderColor: borderColor ? borderColor : "#E0E0E0",
            borderWidth: "1px",
          },
        },
        // ✅ Inner input styling
        "& .MuiOutlinedInput-input": {
          backgroundColor: "#FFFFFF",
          padding: "6px 12px", // ⬅️ reduce padding (smaller height)
          fontSize: fontSize ? fontSize : "15px",
          color: color ? color : "#000000",
          borderRadius: "8px",
          fontFamily: "Inter",
          fontWeight: fontWeight ? fontWeight : 500,
        },

        "& input[type=number]": {
          MozAppearance: "textfield",
        },
        "& input[type=number]::-webkit-outer-spin-button": {
          WebkitAppearance: "auto",
          margin: 0,
        },
        "& input[type=number]::-webkit-inner-spin-button": {
          WebkitAppearance: "auto",
          margin: 0,
        },
        "& .MuiOutlinedInput-input::placeholder": {
          fontSize: placeholderFontSize ? placeholderFontSize : "13px",
          color: placeholderColor ? placeholderColor : "#888888", // Optional
          fontFamily: "Inter",
          opacity: 0.9,
        },
         //  Label color when shrunk or focused
        "& .MuiInputLabel-root": {
          color: "#6C757D", // default label color
          fontFamily: "Inter",
          "&.Mui-focused": {
            color: labelColor, // 👈 color when focused
          },
          "&.MuiInputLabel-shrink": {
            color: labelColor, // 👈 color when shrunk
            fontWeight: 600,
          },
        },
        ...props.sx,
      }}
      {...props}
    />
  );
};

export default CustomTextField;
